// trial-expired-view.js

import $                    from 'jquery';
import { View } from 'backbone';
import contentTemplate      from 'trial-expired-view.ejs';
import formLoadService      from 'FormLoadService.js';
import NotificationService from 'NotificationService.js';
import constants            from 'Constants.js';
import listService          from 'ListService.js'
import RestService          from 'RestService.js'
import util                 from 'util/Util.js';
import { Model }            from 'backbone';
import eventBus             from 'EventBus';

class TrialExpiredView extends View {

    initialize( opts ) {
        this.options = opts || {};

        this.template = contentTemplate;
        this.events = {
            'click #trial-request-button': 'requestTrialExtension',
            'click #trial-request-back': 'backToLogin'
        };

        this.listenTo(this.model, 'change', this.render);
        return this;
    }

    requestTrialExtension(ev){
        const email = RestService.getEmail();
        const token = RestService.getToken();
        RestService.sendTrialExtensionRequest(email, token).then((result)=>{
            $("#trial-expired-instructions").hide();
            $("#trial-extension-requested").show();
        }).catch((error) => {
            console.log(error);
            let msg = error || 'Error while requesting trial extension';
            NotificationService.error(msg);
        }); 
    }

    backToLogin(){
        Backbone.history.loadUrl('login');
    }

    render() {
        $(this.el).html(this.template(this.model.toJSON()));
        $(this.el).parent().addClass('blue-background');
        $("#trial-expired-instructions").show();
        $("#trial-extension-requested").hide();

        this.delegateEvents();
        return this;
    }
}

export default TrialExpiredView;
